import { motion } from "framer-motion";
import { ABOUT } from "@/data/content";

const easeEditorial = [0.16, 1, 0.3, 1];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="px-6 md:px-12 lg:px-16 py-24 md:py-32 lg:py-40 bg-white border-t border-black/10"
    >
      <div className="grid grid-cols-12 gap-6 mb-16 md:mb-24">
        <div className="col-span-6 md:col-span-3">
          <p className="text-[11px] uppercase tracking-[0.22em] text-neutral-500">
            (02) — About
          </p>
        </div>
      </div>

      <div className="grid grid-cols-12 gap-6 md:gap-12 lg:gap-16">
        {/* Pull-quote (replaces portrait) */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: easeEditorial }}
          className="col-span-12 md:col-span-5"
        >
          <div
            data-testid="about-quote"
            className="aspect-[4/5] bg-neutral-50 border border-black/10 flex items-center justify-center p-8 md:p-12"
          >
            <blockquote className="font-serif italic font-light text-2xl sm:text-3xl md:text-4xl leading-[1.15] tracking-tight text-black max-w-[22ch]">
              <span aria-hidden className="block text-5xl md:text-6xl leading-none mb-4 not-italic">
                “
              </span>
              {ABOUT.quote}
            </blockquote>
          </div>
          <p className="mt-4 text-[10px] uppercase tracking-[0.22em] text-neutral-500">
            Isabella Rubino — Florence, Italy
          </p>
        </motion.div>

        {/* Bio */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, delay: 0.2, ease: easeEditorial }}
          className="col-span-12 md:col-span-7 md:pl-8 lg:pl-16"
        >
          <h2
            data-testid="about-heading"
            className="font-serif font-light tracking-tight text-4xl sm:text-5xl md:text-6xl leading-[1.05] mb-10"
          >
            Words that <span className="italic">build worlds</span> — for the
            houses that shape culture.
          </h2>

          <div className="space-y-6 max-w-[58ch]">
            {ABOUT.body.map((p, i) => (
              <p
                key={i}
                data-testid={`about-para-${i}`}
                className="font-sans text-[15px] md:text-base leading-relaxed text-neutral-700"
              >
                {p}
              </p>
            ))}
            <p
              data-testid="about-personal"
              className="font-serif italic text-lg md:text-xl text-black border-l border-black pl-5 !mt-8"
            >
              {ABOUT.personal}
            </p>
          </div>

          {/* Two-column meta */}
          <div className="grid grid-cols-2 gap-8 mt-14 max-w-2xl">
            <div data-testid="about-clients">
              <p className="text-[10px] uppercase tracking-[0.22em] text-neutral-500 mb-4">
                Selected Clients
              </p>
              <ul className="space-y-2">
                {ABOUT.clients.map((c) => (
                  <li
                    key={c}
                    className="font-serif text-lg md:text-xl leading-snug"
                  >
                    {c}
                  </li>
                ))}
              </ul>
            </div>
            <div data-testid="about-disciplines">
              <p className="text-[10px] uppercase tracking-[0.22em] text-neutral-500 mb-4">
                Disciplines
              </p>
              <ul className="space-y-2">
                {ABOUT.disciplines.map((d) => (
                  <li
                    key={d}
                    className="font-serif italic text-lg md:text-xl leading-snug"
                  >
                    {d}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
